<template>
  <div>
    <v-app>
      <v-container fluid>
        <!-- ありがとうございました -->
        <v-row justify="center">
          <v-col cols="auto" class="text-h6 pb-0"
            >ありがとうございます。
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="auto" class="text-h6 pt-0"
            >お支払いが完了いたしました。
          </v-col>
        </v-row>

        <!-- 注文番号 -->
        <!-- <v-row justify="center" class="mt-4">
        <v-col cols="auto">
          <div class="text-h6">注文番号</div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto" class="pt-0">
          <div class="text-h2 pl-3">777</div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col class="text-h6" cols="auto">
          来店予定
        </v-col>
        <v-col class="text-h6 pl-0" cols="auto">
          19:30
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="mt-4 pl-4 pr-4">
        <v-col class="text-body-2"
          >この注文番号は「注文履歴」からいつでも見ることができます。</v-col
        >
      </v-row> -->
        <v-row align="center" justify="center" class="mt-4 pl-4 pr-4">
          <v-col class="text-body-2"
            >ご来店時に注文番号をレジで見せてください。注文番号は「注文履歴」からご確認ください。</v-col
          >
        </v-row>

        <!-- ご注意 -->
        <v-row justify="center" class="subtitle-1 mt-4">
          <v-col cols="auto">
            <v-icon>fas fa-exclamation-circle</v-icon>
            <span class="ml-2 mr-2">ご注意</span>
            <v-icon>fas fa-exclamation-circle</v-icon>
          </v-col>
        </v-row>
        <v-row justify="center" class="pl-4 pr-4">
          <v-col class="text-body-2"
            >ブラウザの「戻る」「×」を押した際に決済途中の画面が表示されることがございますが、決済は完了しておりますのでご安心ください。</v-col
          >
        </v-row>

        <!-- トーク画面へ移動 -->
        <v-row justify="center" class="mt-8" v-if="linkTalkScreen">
          <v-btn
            rounded
            class="custom-transform-class text-none"
            color="success"
            :href="linkTalkScreen"
            >トーク画面へ移動</v-btn
          >
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({}),
  created() {
    this.$store.state.appBar = false;
    this.$store.state.title = "お支払い";
    this.$store.state.cart = false;
  },
  async mounted() {},
  computed: {
    ...mapGetters("settings", ["linkTalkScreen"]),
  },
  watch: {
    // DB 設定読み込んだ後に行う
    linkTalkScreen: function () {
      this.hideProgress();
    },
  },
  methods: {
    ...mapActions(["hideProgress"]),
  },
};
</script>
